import { topicCollections } from '@/mocks/home';

const toneMap: Record<string, { chip: string; icon: string; ring: string }> = {
  primary: { chip: 'bg-primary-100 text-primary-800', icon: 'bg-primary-500', ring: 'border-primary-200' },
  accent: { chip: 'bg-accent-100 text-accent-900', icon: 'bg-accent-500', ring: 'border-accent-300' },
  secondary: { chip: 'bg-secondary-100 text-secondary-900', icon: 'bg-secondary-500', ring: 'border-secondary-200' },
};

export default function TopicCollections() {
  return (
    <section id="collections" className="w-full border-y bg-background-100/70 hairline">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16 lg:px-10">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.18em] text-accent-700">
              <i className="ri-bookmark-3-line text-sm"></i>
              COLLECTION INDEX
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              合集索引 · 顺着线索往下翻
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
              零散的瓜帖按主题归了档，想系统围观某个话题，直接从索引里挑一册进去看。
            </p>
          </div>
          <span className="w-fit rounded-md border bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-700 hairline">
            共 734 帖已归档
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {topicCollections.map((item) => {
            const tone = toneMap[item.tone] ?? toneMap.primary;
            return (
              <article
                key={item.name}
                className={`card-lift group cursor-pointer rounded-lg border bg-background-50 p-5 ${tone.ring} hover:bg-background-50`}
              >
                <div className="flex items-center justify-between">
                  <span className={`flex h-10 w-10 items-center justify-center rounded-md text-base text-background-50 ${tone.icon}`}>
                    <i className="ri-price-tag-3-line"></i>
                  </span>
                  <span className={`rounded-full px-2.5 py-1 text-[11px] font-bold ${tone.chip}`}>
                    {item.count}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {item.name}
                </h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-500">
                  {item.desc}
                </p>
                <span className="mt-4 flex items-center gap-1.5 text-xs font-semibold text-primary-600">
                  展开这一册
                  <i className="ri-arrow-right-line text-sm transition-transform duration-300 group-hover:translate-x-1"></i>
                </span>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}